module.exports = __webpack_public_path__ + "static/media/logo-adipsik-white.5b82010b.png";